import styled from 'styled-components';

export const TakeParentSpace = styled.div`
  width: 100%;
  max-height: 10em;
  max-width: 100%;

  > * {
    max-height: inherit;
    max-width: inherit;
  }
`;
